export default {
  title: "Bedrijfsnummers",

  input: {
    coc: "KvK",
    vat: "BTW",
  },

  button: {
    save: "Opslaan",
  },

  api: {
    patched: "Bedrijfsnummers opgeslagen",
    chamberOfCommerce: {
      notNull: "Voer uw KvK nummer in"
    },
    vat: {
      notNull: "Voer uw BTW nummer in"
    }
  }
}
